import React from 'react';

import styled from 'styled-components';

import { isMainStatementLine } from '../helpers';

const Wrapper = styled.div`
    padding: 0.5rem 0.75rem;
    font-size: ${(props) => props.theme.FontSizeSm};
    margin-top: -2px;
    background-color: white;
`;

const StatementTransactionPercentage = ({ row }) => {
    return <Wrapper>{row.Percentage}%</Wrapper>;
};

export default StatementTransactionPercentage;
